import React, { useEffect, useState } from 'react';

import { SatModal, SatButton, SatCheckBox } from '@components/common/satUI';

/**
 * 알릴의무 작성 전 확인사항
 */
const NoticeDutyCheckPopup = props => {
  const { visible, setVisible, onConfirm } = props;

  const [checkList, setCheckList] = useState({
    check1: false,
    check2: false,
  });

  useEffect(() => {
    if (!visible) {
      setCheckList({
        check1: false,
        check2: false,
      });
    }
  }, [visible]);

  const handleCloseClick = () => {
    setVisible(false);
  };

  const handleConfirmClick = () => {
    onConfirm();
    setVisible(false);
  };

  const handleCheckChange = (key, value) => {
    setCheckList({
      ...checkList,
      [key]: value,
    });
  };

  return (
    <SatModal
      visible={visible}
      setVisible={handleCloseClick}
      type="type-a"
      wide
    >
      <header className="modal-header">
        <h3 className="layer-tit2">알릴의무 작성 전 확인사항</h3>
      </header>
      <div className="cont">
        <div className="modal-scroll-wrap">
          <div className="info-box mgb-0">
            <ul className="dot-type type-m huge mgt-8">
              <li>
                타사 지급정보는 고객의 민감정보이므로 반드시 고객님의 지급력
                공유 의사를 확인하신 후 열람진행 해야합니다.
              </li>
              <li>
                사전심사 동의서사 '제공에 관한 사항 &middot; 제공받는 자의
                이용목적 : 보험체결(권유) 과정 중 피보험자 보험금 지급이력
                정보열람 및 인수여부 안내를 위한 이용'
                <p className="notice-txt">
                  ※ 해당 내용을 정확히 고객님에게 꼭 안내 후 진행해 주세요
                </p>
                <p className="notice-txt">
                  ※ 아래 내용을 확인 후 체크하셔야 진행이 가능합니다.
                </p>
              </li>
            </ul>
          </div>
          <div className="check-wrap chk-style no-space mgt-12">
            <SatCheckBox
              value={[checkList['check1']]}
              options={[
                {
                  label:
                    '고객에게 정확한 설명을 통해 타보험사 지급이력이 공유 될 수 있음을 전달 및 동의 후 진행합니다.',
                  value: true,
                },
              ]}
              onChange={value => {
                handleCheckChange('check1', value);
              }}
            />
          </div>
          <div className="check-wrap chk-style no-space mgt-12">
            <SatCheckBox
              value={[checkList['check2']]}
              options={[
                {
                  label:
                    '고객의 정상적인 동의없이 진행할 경우 설계사에게 책임이 부과됩니다.',
                  value: true,
                },
              ]}
              onChange={value => {
                handleCheckChange('check2', value);
              }}
            />
          </div>
        </div>
      </div>
      {/*<!-- S : 버튼 영역 (각 상황에 맞게 버튼을 추가해두었습니다.)-->*/}
      <div className="btn-wrap">
        <SatButton
          styleClass="btn btn-white"
          label="취소"
          onClick={handleCloseClick}
        />
        <SatButton
          styleClass="btn btn-yellow"
          disabled={Object.keys(checkList).find(key => !checkList[key])}
          label="확인"
          onClick={handleConfirmClick}
        />
      </div>
      {/*<!-- E : 버튼 영역-->*/}
      <SatButton
        styleClass="btn-layer-close modal-close"
        label="창닫기"
        onClick={handleCloseClick}
      />
    </SatModal>
  );
};

export default NoticeDutyCheckPopup;
